module.exports = __webpack_public_path__ + "media/images/projects/picto_humains-a770b0da72d908c5919fdd31c6896165.svg";